import { ReportData } from '../types/reportTypes';

// October 2025 Sales Data - Standard Report (30 jobs from CSV)
const jobData = [
  {
    jobInfo: "E-672: Shavon Ware",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 7972.00,
    grossMarginPct: 0.7292,
    grossProfit: 5813.00,
    commissionPercentage: 10.00,
    salesCommission: 797.20,
    salesManagerFee: 79.72,
    companyOH: 1235.66,
    netProfit: 0
  },
  {
    jobInfo: "E-667: Forrest&Eunsil Huang",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 2972.00,
    grossMarginPct: 0.3204,
    grossProfit: 952.10,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 29.72,
    companyOH: 460.66,
    netProfit: 0
  },
  {
    jobInfo: "E-668: Michael & Jackie Falkenheim",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 10905.00,
    grossMarginPct: 0.4000,
    grossProfit: 4362.00,
    commissionPercentage: 4.00,
    salesCommission: 436.20,
    salesManagerFee: 109.05,
    companyOH: 1690.28,
    netProfit: 0
  },
  {
    jobInfo: "E-664: John & Cathy Gunter",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 9992.00,
    grossMarginPct: 0.4090,
    grossProfit: 4086.83,
    commissionPercentage: 4.00,
    salesCommission: 399.68,
    salesManagerFee: 99.92,
    companyOH: 1548.76,
    netProfit: 0
  },
  {
    jobInfo: "E-657: James Sanny Sr.",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 14412.31,
    grossMarginPct: 0.4000,
    grossProfit: 5764.92,
    commissionPercentage: 4.00,
    salesCommission: 576.49,
    salesManagerFee: 144.12,
    companyOH: 2233.91,
    netProfit: 0
  },
  {
    jobInfo: "E-666: Jobin K & chiinchu George",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 4872.00,
    grossMarginPct: 0.3375,
    grossProfit: 1644.38,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 48.72,
    companyOH: 755.16,
    netProfit: 0
  },
  {
    jobInfo: "E-661: Nita & Ahkeem Brown",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 17912.00,
    grossMarginPct: 0.5347,
    grossProfit: 9577.63,
    commissionPercentage: 7.00,
    salesCommission: 1253.84,
    salesManagerFee: 179.12,
    companyOH: 2776.36,
    netProfit: 0
  },
  {
    jobInfo: "E-662: Gregory Thomas",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 29972.00,
    grossMarginPct: 0.4000,
    grossProfit: 11988.80,
    commissionPercentage: 4.00,
    salesCommission: 1198.88,
    salesManagerFee: 299.72,
    companyOH: 4645.66,
    netProfit: 0
  },
  {
    jobInfo: "E-659: Carole & James Geronimo",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 7621.00,
    grossMarginPct: 0.4000,
    grossProfit: 3048.40,
    commissionPercentage: 4.00,
    salesCommission: 304.84,
    salesManagerFee: 76.21,
    companyOH: 1181.26,
    netProfit: 0
  },
  {
    jobInfo: "E-658: Daniel & Eileen Borchers",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 5928.00,
    grossMarginPct: 0.4802,
    grossProfit: 2846.83,
    commissionPercentage: 4.00,
    salesCommission: 237.12,
    salesManagerFee: 59.28,
    companyOH: 918.84,
    netProfit: 0
  },
  {
    jobInfo: "Charlene Templeton",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 17772.00,
    grossMarginPct: 0.4660,
    grossProfit: 8281.93,
    commissionPercentage: 4.00,
    salesCommission: 710.88,
    salesManagerFee: 177.72,
    companyOH: 2754.66,
    netProfit: 0
  },
  {
    jobInfo: "David& Devon Gessert",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 34709.00,
    grossMarginPct: 0.6543,
    grossProfit: 22709.90,
    commissionPercentage: 10.00,
    salesCommission: 3470.90,
    salesManagerFee: 347.09,
    companyOH: 5379.90,
    netProfit: 0
  },
  {
    jobInfo: "Towanda Madden",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 8450.00,
    grossMarginPct: 0.4000,
    grossProfit: 3380.00,
    commissionPercentage: 4.00,
    salesCommission: 338.00,
    salesManagerFee: 84.50,
    companyOH: 1309.75,
    netProfit: 0
  },
  {
    jobInfo: "Leslie Manzon",
    leadSource: "Referral - From past customer",
    trade: "Roofing",
    contractTotal: 21572.00,
    grossMarginPct: 0.4379,
    grossProfit: 9445.79,
    commissionPercentage: 4.00,
    salesCommission: 862.88,
    salesManagerFee: 215.72,
    companyOH: 3343.66,
    netProfit: 0
  },
  {
    jobInfo: "Jane & James Cosgrove",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 34500.00,
    grossMarginPct: 0.4252,
    grossProfit: 14667.88,
    commissionPercentage: 4.00,
    salesCommission: 1380.00,
    salesManagerFee: 345.00,
    companyOH: 5347.50,
    netProfit: 0
  },
  {
    jobInfo: "Alexander & Brenda Tarasco",
    leadSource: "Previous Customer",
    trade: "Siding",
    contractTotal: 18872.00,
    grossMarginPct: 0.4000,
    grossProfit: 7548.80,
    commissionPercentage: 4.00,
    salesCommission: 754.88,
    salesManagerFee: 188.72,
    companyOH: 2925.16,
    netProfit: 0
  },
  {
    jobInfo: "Bill & Jessica Bamford",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 4772.00,
    grossMarginPct: 0.6427,
    grossProfit: 3067.13,
    commissionPercentage: 10.00,
    salesCommission: 477.20,
    salesManagerFee: 47.72,
    companyOH: 739.66,
    netProfit: 0
  },
  {
    jobInfo: "E-651: Linda McClellan",
    leadSource: "Previous Customer",
    trade: "Painting & Others",
    contractTotal: 1600.00,
    grossMarginPct: 0.4983,
    grossProfit: 797.33,
    commissionPercentage: 4.00,
    salesCommission: 64.00,
    salesManagerFee: 16.00,
    companyOH: 248.00,
    netProfit: 0
  },
  {
    jobInfo: "E-650: Cheryl Jenner",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 18591.00,
    grossMarginPct: 0.5613,
    grossProfit: 10435.61,
    commissionPercentage: 7.00,
    salesCommission: 1301.37,
    salesManagerFee: 185.91,
    companyOH: 2881.61,
    netProfit: 0
  },
  {
    jobInfo: "E-646: Shelley Savage",
    leadSource: "Referral - Word of mouth",
    trade: "Gutters",
    contractTotal: 5634.00,
    grossMarginPct: 0.6986,
    grossProfit: 3936.00,
    commissionPercentage: 10.00,
    salesCommission: 563.40,
    salesManagerFee: 56.34,
    companyOH: 873.27,
    netProfit: 0
  },
  {
    jobInfo: "E-673: Robyn Williams",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 25000.00,
    grossMarginPct: 0.6526,
    grossProfit: 16316.04,
    commissionPercentage: 10.00,
    salesCommission: 2500.00,
    salesManagerFee: 250.00,
    companyOH: 3875.00,
    netProfit: 0
  },
  {
    jobInfo: "E-648: Beverly Dory",
    leadSource: "Thumbtack",
    trade: "Roofing",
    contractTotal: 8031.00,
    grossMarginPct: 0.4830,
    grossProfit: 3879.02,
    commissionPercentage: 4.00,
    salesCommission: 321.24,
    salesManagerFee: 80.31,
    companyOH: 1244.81,
    netProfit: 0
  },
  {
    jobInfo: "Nita & Ahkeem Brown",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 4972.00,
    grossMarginPct: 0.4000,
    grossProfit: 1988.80,
    commissionPercentage: 4.00,
    salesCommission: 198.88,
    salesManagerFee: 49.72,
    companyOH: 770.66,
    netProfit: 0
  },
  {
    jobInfo: "Jarred & Emily Vallozzi",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 4472.00,
    grossMarginPct: 0.4072,
    grossProfit: 1821.00,
    commissionPercentage: 4.00,
    salesCommission: 178.88,
    salesManagerFee: 44.72,
    companyOH: 693.16,
    netProfit: 0
  },
  {
    jobInfo: "Lynne Muller O'Keefe",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 15750.00,
    grossMarginPct: 0.5680,
    grossProfit: 8946.64,
    commissionPercentage: 7.00,
    salesCommission: 1102.50,
    salesManagerFee: 157.50,
    companyOH: 2441.25,
    netProfit: 0
  },
  {
    jobInfo: "Chelsea & James Forsythe",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 8541.00,
    grossMarginPct: 0.6981,
    grossProfit: 5962.62,
    commissionPercentage: 10.00,
    salesCommission: 854.10,
    salesManagerFee: 85.41,
    companyOH: 1323.86,
    netProfit: 0
  },
  {
    jobInfo: "E-678: Morgan Kaper",
    leadSource: "RoofHero",
    trade: "Roofing",
    contractTotal: 22927.00,
    grossMarginPct: 0.4735,
    grossProfit: 10855.59,
    commissionPercentage: 4.00,
    salesCommission: 917.08,
    salesManagerFee: 229.27,
    companyOH: 3553.69,
    netProfit: 0
  },
  {
    jobInfo: "E-676: Matt & Karey Crain",
    leadSource: "eLocal",
    trade: "Gutters",
    contractTotal: 1721.00,
    grossMarginPct: 0.4382,
    grossProfit: 754.13,
    commissionPercentage: 4.00,
    salesCommission: 68.84,
    salesManagerFee: 17.21,
    companyOH: 266.76,
    netProfit: 0
  },
  {
    jobInfo: "E-682: Dave Clader",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 3792.00,
    grossMarginPct: 0.5187,
    grossProfit: 1966.75,
    commissionPercentage: 7.00,
    salesCommission: 265.44,
    salesManagerFee: 37.92,
    companyOH: 587.76,
    netProfit: 0
  },
  {
    jobInfo: "E-645: Joclyn & Chris Frelier Miller",
    leadSource: "Referral - From past customer",
    trade: "Roofing",
    contractTotal: 8000.00,
    grossMarginPct: 0.5048,
    grossProfit: 4038.19,
    commissionPercentage: 7.00,
    salesCommission: 560.00,
    salesManagerFee: 80.00,
    companyOH: 1240.00,
    netProfit: 0
  }
];

// Apply business logic to calculate net profit (Standard Report formula)
jobData.forEach(job => {
  // For Standard Reports: Net Profit = Gross Profit - (Sales Commission + Sales Manager Fee + Company OH)
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);
const totalManagerFees = jobData.reduce((sum, job) => sum + job.salesManagerFee, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);

// Ad spend data from CSV
const adSpendData = [
  { source: "Networx", spend: 2142.00 },
  { source: "Thumbtack", spend: 16800.00 },
  { source: "Yelp", spend: 9421.93 },
  { source: "Porch", spend: 265.10 },
  { source: "Web to Lead Form", spend: 4690.00 },
  { source: "Angi", spend: 2530.00 },
  { source: "Homebuddy", spend: 2025.00 },
  { source: "RoofHero", spend: 1080.00 },
  { source: "Google Organic Search", spend: 7000.00 },
  { source: "Google Paid Search", spend: 6292.00 },
  { source: "Facebook / Meta Ads", spend: 2718.67 },
  { source: "33 Mile Radius / Everconnect", spend: 2872.00 },
  { source: "eLocal", spend: 2000.00 },
  { source: "BBB", spend: 300.00 },
  { source: "Missed Call", spend: 0.00 },
  { source: "Previous Customer", spend: 0.00 },
  { source: "Other", spend: 0.00 },
  { source: "Blank", spend: 0.00 },
  { source: "Truck", spend: 0.00 },
  { source: "Referral - From past customer", spend: 0.00 },
  { source: "DataDump GoHighLevel", spend: 0.00 },
  { source: "Referral - Word of mouth", spend: 0.00 },
  { source: "Email Campaign", spend: 0.00 },
  { source: "SpringConnect - Call Center", spend: 0.00 },
  { source: "Self Generated Lead (By Rep)", spend: 0.00 },
  { source: "Suburban MD Spring Home Show- Upper Marlboro 2025", spend: 0.00 },
  { source: "Yard Sign", spend: 0.00 }
];

const totalAdSpend = adSpendData.reduce((sum, item) => sum + item.spend, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap).sort((a, b) => b.totalSales - a.totalSales);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap).sort((a, b) => b.totalSales - a.totalSales);

// Create the final report data object
export const octoberData: ReportData = {
  kpis: {
    // Total ad spend
    adSpend: totalAdSpend,

    // Sum of all contract totals
    totalSales: totalContractValue,

    // Sum of all gross profits
    grossProfit: totalGrossProfit,

    // Sum of all sales commissions
    salesCommissions: totalSalesCommissions,

    // Sum of all manager fees
    managerFees: totalManagerFees,

    // Company overhead
    companyOH: totalCompanyOH,

    // Net profit (standard calculation) minus ad spend
    netProfit: totalNetProfit - totalAdSpend,

    // Net profit as percentage of total sales
    netProfitPercent: (totalNetProfit - totalAdSpend) / totalContractValue,

    // Gross profit as percentage of total sales
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  // Ad spend by source with all sources
  adSpendBySource: adSpendData,

  // Sales by lead source - aggregated above
  salesBySource: salesBySource,

  // Sales by trade - aggregated above
  salesByTrade: salesByTrade,

  // Individual job data
  jobData: jobData,

  // Report period information
  period: {
    month: 10, // October
    year: 2025
  }
};
